export default {
  pageTitle: 'ベッセル製作',
  metaDescription: 'TEFはステンレス鋼、チタン、デュプレックスなど特殊材料を用いて、圧力容器、反応槽、貯蔵タンク、オートクレーブを製作しています。',
  sidebar: {
    title: '製作品一覧',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: 'タワー製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  productName: 'ベッセル',
  description: '以下は、当社のベッセル製作における、様々な材質・種類・仕様に関する実績カタログです。',
};
